// Button text constants
export const BTN_CANCEL = "Cancel";
export const BTN_COMPLETE = "Complete";
export const BTN_SAVE_UPDATE = "Save & Update";
export const BTN_SAVE_DRAFT = "Save Draft";
export const BTN_SAVE_MILESTONE = "Save Milestone";
export const BTN_VERIFY_LINK = "Verify Link";

// Form labels
export const FORM_LABEL_MILESTONE_CODE = "Unique ID";
export const FORM_LABEL_MILESTONE_NAME = "Milestone Name";
export const FORM_LABEL_MILESTONE_DESCRIPTION = "Description";
export const FORM_LABEL_STATUS = "Status";
export const FORM_LABEL_MILESTONE_STATUS = "Milestone Status";
export const FORM_LABEL_TRIMESTER = "Trimester";
export const FORM_LABEL_ADMIN_ROLE = "Role";
export const FORM_LABEL_ADMIN_NAME = "Name";
export const FORM_LABEL_ADMIN_EMAIL_ID = "Email ID";
export const FORM_LABEL_USER_STATUS = "User Status";
export const FORM_LABEL_POINTS_RANGE = "Points Range (25-150)";
export const FORM_LABEL_MILESTONE_TYPE = "Type";

// form placeholders
export const FORM_PLACEHOLDER_TEXTFIELD = "Type here...";
export const FORM_PLACEHOLDER_SINGLE_CODE = "Eg: 4032";
export const FORM_PLACEHOLDER_MULTI_CODE =
  "Eg: 4030, 4031, 4032, 4033, 4034, 4035, 4036, 4037";
export const FORM_PLACEHOLDER_TRIMESTER_DROPDOWN = "Select Trimester";
export const FORM_PLACEHOLDER_MILESTONE_TYPE_DROPDOWN = "Select Type";
export const FORM_PLACEHOLDER_MILESTONE_DESCRIPTION = "Milestone Description";
export const FORM_PLACEHOLDER_EDUCATION_DESCRIPTION =
  "Education Description Type here...";
export const FORM_PLACEHOLDER_SELECT_REASON = "Select";

// Education content form labels
export const FORM_LABEL_CODE = "Unique ID";
export const FORM_LABEL_TYPE = "Type";
export const FORM_LABEL_NAME = "Milestone Name";
export const FORM_LABEL_TRIMESTERORGENERAL = "Trimesters/General";
export const FORM_LABEL_DESCRIPTION = "Description";
export const FORM_LABEL_CONTENT_TYPE = "Content Type";
export const FORM_LABEL_LEARNING_CONTENT_ID = "Learning Content Code";
export const FORM_LABEL_URL_LINK = "URL Link";

// Page headers
export const PAGE_HEADER_CREATE_MILESTONE_CONTENT = "Create Milestone Content";
export const PAGE_HEADER_EDIT_MILESTONE_CONTENT =
  "View / Edit Milestone Content";
export const PAGE_HEADER_ADD_ADMIN = "Add Admin";
export const PAGE_HEADER_EDIT_ADMIN = "View / Edit Admin";
export const CLAIM_REDEMPTION = "Process Redemption";
export const PATIENT_DETAILS = "Patient Detail";

// Tab labels
export const TAB_LABEL_MILESTONE_DETAILS = "Care Plan Milestone";
export const TAB_LABEL_ACTIVITY_HISTORY = "Activity History";
export const TAB_LABEL_EDUCATION_CONTENT = "Education Milestone";
export const TAB_LABEL_MANAGE_USERS = "Manage Admins";
export const TAB_LABEL_MANAGE_PATIENTS = "Manage Patients";
export const TAB_LABEL_MANAGE_MILESTONES = "Manage Milestones";
export const TAB_LABEL_REPORTS = "Reports";
export const TAB_LABEL_MANAGE_REDEMPTIONS = "Manage Redemptions";

//Patient dashboard Tab labels
export const TAB_LABEL_CARE_PLAN_MILESTONE = "Care Plan Milestone";
export const TAB_LABEL_EDUCATION_LIBRARY = "Education Library";
export const TAB_LABEL_ULTRASOUND_SCAN = "Ultrasound Scan";
export const TAB_LABEL_IMAGE_THEME = "Image Theme";
// static messages
export const CONTACT_ADMIN = "Contact Admin";
export const WELCOME_TO_MM = "Welcome to Mommy Milestones";

//Helper Texts
export const CODE_HELPER_TEXT = "Enter multiple codes as comma separated";

// Table header text
export const MANAGE_REDEMPTION_TABLE_HEADER = "Patient Redemption Dashboard";
export const MANAGE_MILESTONES_TABLE_HEADER = "Milestone List";
export const MANAGE_PATIENTS_TABLE_HEADER = "Patient List";

export const MANAGE_REDEMPTION_SEARCH_PLACEHOLDER =
  "Search by Patient MRN No, Status";
export const MANAGE_PATIENT_SEARCH_PLACEHOLDER =
  "Search by Patient MRN No, Name, Status";

// Welcome banner text
export const WELCOME_BANNER_MESSAGE = `Congratulations on starting this exciting journey of growing your family! We know it's not always easy to stay on top of everything you need to keep yourself and your baby healthy. That's why we're here to support and guide you every step of the way. With Mommy Milestones, you'll get:`;
export const BULLET_POINTS = [
  "Easy tools to track your pregnancy and progress",
  "Helpful tips, videos and articles to keep you and your baby healthy",
  "Fun rewards for staying on track and taking care of yourself!",
];
export const WELCOME_BANNER_ENDLINE =
  "We're here to make your pregnancy journey easier, joyful, and special.";

// My reward activity page text
export const MY_REWARD_ACTIVITY_TOP_TEXT =
  "You're doing an amazing job! Every small step you take to care for yourself and your baby is a significant win, and it's earning you rewards along the way! Take a moment to reflect on your progress so far and keep pushing forward. You're closer than you think to reaching the next reward. Your hard work makes a difference for both you and your baby. Keep it up; you've got this!";

export const MY_REWARD_ACTIVITY_FOOTER_TEXT =
  "Points today, rewards tomorrow!  You're building a strong healthy future for yourself and baby.";

// footer text
export const FOOTER_NOTE =
  "The Care Plan Milestones and Education Activities reflected in Mommy Milestones are not exhaustive. Please always refer to medical guidance from your physician and clinic.";
export const FOOTER_TEXT =
  "©2024 Mommy Milestones. Philadelphia, PA. All rights reserved.";
export const LABEL_SELECT_OPTOUT_REASON = "Select Opt Out reason";
export const PLACEHOLDER_SELECT_OPTOUT_REASON = "Select Reason";

export const LOGIN_PAGE_CONTENT = {
  welcomeTitle: "Welcome to",
  welcomeSubtitle: "Mommy Milestones",
  description:
    "Mommy Milestones Provides tools to track your pregnancy and progress",
  features: [
    "Helpful tips, videos, and articles to keep you and your baby healthy",
    "Fun rewards for staying on track and taking care of yourself!",
  ],
  description_end:
    "We're here to make your pregnancy journey easier, joyful, and special.",
  footerText: "©2024 Mommy Milestone. Philadelphia, PA. All rights reserved.",
};

// Ultrrrasound scan

export const ULTRRSOUND_SCAN_DESCRIPTION = `Embark on an exciting journey through your pregnancy with a closer look
        at your baby’s development through each ultrasound scan. Explore the
        incredible milestones and changes week by week, and witness the growth
        of your little one in the most intimate way. Each scan brings a new
        chapter of your pregnancy story, giving you a deeper connection to your
        baby’s journey from embryo to fetus. Get ready to experience the magic
        of these beautiful moments!`;
export const ULTRRSOUND_SCAN_HEADER = "Ultrasound Scan Images";
export const REDEMPTION_ADMIN = "RedemptionAdmin";
export const SUPER_ADMIN = "SuperAdmin";
// Patient Details Headings
export const ENROLLMENT_DATE = "Enrollment Date";
export const DUE_DATE = "Due Date";
export const PATIENT_STATUS = "Patient Status";
export const CURRENT_WEEK_TASK = "Current Week Group";
export const CURRENT_TASK_PROGRESS = "Milestone Progress";
export const REWARDS_TIER_LEVEL = "Rewards Tier Level";
export const REWARD_POINTS = "Reward Points";

// label for patient details
export const LABEL_REASON = "Reason";
export const PLACEHOLDER_REASON = "Select Reason";

export const LABEL_COMMENT = "Comment";
export const PLACEHOLDER_COMMENT = "Add Comment";

export const BTN_SAVE_PATIENT_DETAILS = "Save";

// User Placeholders
export const PLACEHOLDER_ROLE = "Select Role";
export const PLACEHOLDER_STATUS = "Select Status";

// Ultrasound PopUp
export const ULTRASOUND_SCAN = "Ultrasound Scan";
export const ULTRASOUND_SCAN_DESCRIPTION =
  "Discover the beautiful progress of your baby's development with each week's ultrasound scan, now in full view for you to cherish every moment.";
// Admin Milestone label

export const ADMIN_MILESTONE_MULTILANGUAGE_LABEL =
  "Supports multiple languages";
// Multi language form texts
export const MULTI_LANGUAGE_SUPPORT = "Multiple language support";
export const MULTI_LANGUAGE_SUPPORT_NOTE =
  "Please enter authorized language content only";
export const SUPPORT_MULTILANGUAGE_TEXT = "Supports multiple languages: ";

// Confirmation Modal Texts
export const CONFIRMATION = "Confirmation";
export const CONFIRMATION_MESSAGE =
  "Please make sure you are using the pre-approved content for language updates. Validate the code and the name for correctness.";
export const CONFIRMATION_NOTE =
  "Are you sure you want to save this milestone?";
// snackbar messages
export const INVALID_URL_MSG = "Invalid URL format";

// English code

export const ENGLISH_LANGUAGE_CODE = "en";
export const SPANISH_LANGUAGE_CODE = "es";

export type ENGLISH_LANGUAGE_CODE_TYPE = "en";
export type SPANISH_LANGUAGE_CODE_TYPE = "es";

// No permission
export const NO_PERMISSION_TEXT =
  "You do not have permission to access this page Please contact admin";
export const ACCESS_DENIED = "Access Denied";

//Tier status
export const TIER_STATUS = {
  COMPLETED: "Completed",
  ELIGIBLE: "Eligible",
};
